import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import classNames from 'classnames'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const clientNotesColumn: GridColumn[] = [
  {
    title: 'Description',
    field: 'description',
    show: true,
    filterable: false,
    className: classNames('table-columns__content', 'table-columns__break-word'),
  },
  {
    title: 'Created Date',
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
    show: true,
    width: 120,
    minResizableWidth: 120,
  },
  {
    title: 'Updated Date',
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem.updatedDate, true)}
      </td>
    ),
    show: true,
    width: 120,
    minResizableWidth: 120,
  },
  {
    title: 'Created By',
    cell: (props: GridCellProps) => (
      <td className='table-columns__content'>{props.dataItem?.createdBy?.name}</td>
    ),
    show: true,
    width: 180,
  },
  {
    title: 'Updated By',
    cell: (props: GridCellProps) => (
      <td className='table-columns__content'>{props.dataItem?.updatedBy?.name}</td>
    ),
    show: true,
    width: 180,
  },
]
